import { DataTable, useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { getDefaultPermissions } from '../../../backend/features/permissions';
import { useArchivedFileTable, useDocumentLibraryTranslations } from '../../hooks';
import { DocumentLibraryContext } from '../../providers';
export function ArchivedFileManager(props) {
    var _a;
    const userState = useUserState();
    const { t } = useDocumentLibraryTranslations();
    const { handleCurrentDirectoryId } = React.useContext(DocumentLibraryContext);
    const [searchParams] = useSearchParams();
    const ownerId = searchParams.get('ownerId') || undefined;
    const staticFilterData = {
        ownerId: ownerId,
        currentUserId: userState.id,
    };
    const { dataTableProps } = useArchivedFileTable({
        useDataTableFunction: useDataTableUsingUrl,
        defaultPermissions: getDefaultPermissions(),
        currentDirectoryId: props.currentDirectoryId,
        navigate: props.navigate,
        staticFilterData: staticFilterData,
    });
    React.useEffect(() => {
        handleCurrentDirectoryId(props.currentDirectoryId);
    }, [props.currentDirectoryId, handleCurrentDirectoryId]);
    return React.createElement(DataTable, Object.assign({}, dataTableProps, { title: t('documentPanel.archived'), filteredRowCount: (_a = dataTableProps.filteredRowCount) !== null && _a !== void 0 ? _a : 0 }));
}
